import React, {useState} from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {FormattedMessage, useIntl} from "react-intl";
import {RootStateOrAny, useDispatch, useSelector} from "react-redux";
import {update} from "../_redux/profileCrud";
import {handleError} from "../../../../utils/helpers/helpers";

const initialValues = {
  name: "",
  email: "",
};

const ProfileEdit = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootStateOrAny) => state.auth);

  const [loading, setLoading] = useState(false);

  initialValues.email = user?.email;
  initialValues.name = user?.name;

  const RegistrationSchema = Yup.object().shape({
    email: Yup.string()
      .typeError(intl.formatMessage({ id: "AUTH.VALIDATION.VALID_EMAIL" }))
      .email(intl.formatMessage({ id: "AUTH.VALIDATION.VALID_EMAIL" }))
      .min(
        3,
        intl.formatMessage({ id: "AUTH.VALIDATION.MIN_LENGTH" }, { length: 3 })
      )
      .max(
        50,
        intl.formatMessage({ id: "AUTH.VALIDATION.MAX_LENGTH" }, { length: 50 })
      )
      .required(intl.formatMessage({ id: "AUTH.VALIDATION.REQUIRED_FIELD" })),

    name: Yup.string()
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        'Name can only contain Latin letters.'
      )
      .matches(/^\s*[\S]+(\s[\S]+)+\s*$/gms,'Please enter your full name.')
      .min(
        7,
        intl.formatMessage({ id: "AUTH.VALIDATION.MIN_LENGTH" }, { length: 3 })
      )
      .max(
        50,
        intl.formatMessage({ id: "AUTH.VALIDATION.MAX_LENGTH" }, { length: 50 })
      )
      .required(intl.formatMessage({ id: "AUTH.VALIDATION.REQUIRED_FIELD" })),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: RegistrationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setSubmitting(true);
      enableLoading();

      update({email: values.email, name: values.name})
        .then(async ({ data: { user } }) => {
          dispatch(props.fulfillUser(user));
        })
        .catch((err) => {
          setStatus(handleError(err));
        })
        .finally(() => {
          disableLoading();
          setSubmitting(false);
          window.location.reload();
        });
    },
  });

  return (
    <div className="card">
      <div className="card-body">
        <div className="login-signin p-5" style={{ display: "block" }}>
          <form
            id="kt_login_signin_form"
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
            onSubmit={formik.handleSubmit}
          >

            {/* begin: Name */}
            <div className="form-group fv-plugins-icon-container">
              <label className="font-weight-bold">
                <FormattedMessage id="PAGE.PROFILE.TAB.INFO.NAME" />
              </label>
              <input
                type="text"
                className={`form-control h-auto py-5 px-6 ${getInputClasses(
                  "name"
                )}`}
                name="name"
                placeholder={intl.formatMessage({id: "PAGE.PROFILE.TAB.INFO.NAME"})}
                {...formik.getFieldProps("name")}
              />
              {formik.touched.name && formik.errors.name ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.name}</div>
                </div>
              ) : null}
            </div>
            {/* end: Name */}

            {/* begin: Email */}
            <div className="form-group fv-plugins-icon-container">
              <label className="font-weight-bold">
                <FormattedMessage id="PAGE.PROFILE.TAB.INFO.EMAIL" />
              </label>
              <input
                type="email"
                className={`form-control h-auto py-5 px-6 ${getInputClasses(
                  "email"
                )}`}
                name="email"
                placeholder={intl.formatMessage({id: "PAGE.PROFILE.TAB.INFO.EMAIL"})}
                {...formik.getFieldProps("email")}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.email}</div>
                </div>
              ) : null}
            </div>
            {/* end: Email */}

            <div className="form-group d-flex flex-wrap">
              <button
                type="submit"
                disabled={
                  formik.isSubmitting ||
                  !formik.isValid
                }
                className="btn btn-primary font-weight-bold px-9 py-4 my-3"
              >
                <span>
                  <FormattedMessage id="AUTH.GENERAL.SUBMIT_BUTTON" />
                </span>
                {loading && (
                  <span className="ml-3 spinner spinner-white"></span>
                )}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default ProfileEdit;
